const cache: Record<string, any> = {}

const MCCache = {
    get<T>(key: string): T {
        return cache[key]
    },
    set<T>(key: string, value: T) {
        cache[key] = value
    },
    delete(key: string) {
        delete cache[key]
    },
}

export default MCCache
